import MainLayout from "../layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function NotFound() {
  const { t } = useTranslation();
  return (
    <MainLayout pageCSS="not-found-page">
      <div className="not-found-page__main-text">
        <h2>{t("404_page_main_text_primary")}</h2>
        <h3>{t("404_page_main_text_secondary")}</h3>
        <p>{t("404_page_main_text_tetiary")}</p>
        <Link className="btn btn-blue btn-shadow u-mt-small" to="/">
          {t("404_page_main_return_button")}
        </Link>
      </div>
    </MainLayout>
  );
}

export default NotFound;
